module.exports = __webpack_public_path__ + "media/images/city/052-quinta-of-saint-peter-of-alexandria-074ba1fbb580822008399fde20ff694c.svg";